export type EnvSource = (id: string) => string | undefined

export class FeatureFlipEnvDataSource {
  constructor(
    private readonly errorLogger: (e: Error) => void,
    private readonly envSource: EnvSource,
  ) {}

  check(id: string): boolean {
    const featureFlip: string | undefined = this.envSource(id)
    if (featureFlip === undefined) {
      this.errorLogger(new Error(`Feature flip ${id} non trouvé dans les variables d'environnement`))
      return false
    }

    return featureFlip === 'yes'
  }
}
